export default {
    forms: {
        primary: {
            text: {
                options: {
                    facets: ['base'],
                    hasFloatingLabel: false,
                    title: 'Primary text field: Input',
                },
                sections: [
                    {
                        title: 'Usage',
                        examples: [
                            {
                                label: 'Basic usage',
                                value: '',
                            },
                            {
                                label: 'Placeholder usage',
                                value: '',
                                placeholder: 'Placeholder',
                            },
                            {
                                label: 'Filled',
                                value: 'Non omnis sapiente',
                            },
                            {
                                label: 'Required',
                                value: 'Minima quam quibusdam',
                                required: true,
                            },
                        ],
                    },
                    {
                        title: 'States',
                        examples: [
                            {
                                label: 'Focused',
                                value: 'Provident recusandae',
                                focus: true,
                            },
                            {
                                label: 'Disabled (empty with placeholder)',
                                value: '',
                                placeholder: 'Placeholder',
                                disabled: true,
                            },
                            {
                                label: 'Disabled (filled)',
                                value: 'Odio perspiciatis',
                                disabled: true,
                            },
                        ],
                    },
                    {
                        title: 'Form states',
                        examples: [
                            {
                                label: 'Error state',
                                value: 'Nobis pariatur',
                                'has-errors': true,
                                messages: { error: ['Error message'] },
                            },
                        ],
                    },
                ],
            },
            textarea: {
                options: {
                    facets: ['base'],
                    hasFloatingLabel: false,
                    title: 'Primary text field: Textarea',
                },
                sections: [
                    {
                        title: 'Usage',
                        examples: [
                            {
                                label: 'Basic usage',
                                value: '',
                            },
                            {
                                label: 'Placeholder usage',
                                value: '',
                                placeholder: 'Placeholder',
                            },
                            {
                                label: 'Filled',
                                value: 'A aliquam asperiores aspernatur at blanditiis culpa dolores, fuga id iste iure numquam perferendis porro quia quibusdam quidem sit sunt.',
                            },
                        ],
                    },
                    {
                        title: 'States',
                        examples: [
                            {
                                label: 'Focused',
                                value: 'Ex expedita illum',
                                focus: true,
                            },
                            {
                                label: 'Disabled (empty with placeholder)',
                                value: '',
                                placeholder: 'Placeholder',
                                disabled: true,
                            },
                            {
                                label: 'Disabled (filled)',
                                value: 'Delectus deserunt doloribus excepturi labore magnam nobis, obcaecati possimus quam rerum sequi. Adipisci, aperiam dolor hic iste perspiciatis qui repellendus.',
                                disabled: true,
                            },
                        ],
                    },
                    {
                        title: 'Form states',
                        examples: [
                            {
                                label: 'Error state',
                                value: 'Aspernatur cumque cupiditate dolorum, expedita iusto laborum natus obcaecati saepe sed, sequi tempora ullam ut vitae.',
                                'has-errors': true,
                                messages: { error: ['Error message'] },
                            },
                        ],
                    },
                ],
            },
            select: {
                simple: {
                    options: {
                        facets: ['base'],
                        title: 'Primary text field: Select',
                    },
                    sections: [
                        {
                            title: 'Usage',
                            examples: [
                                {
                                    label: 'Basic usage',
                                    value: '',
                                    items: [{ value: 'Cat' }, { value: 'Dog' }, { value: 'Mouse' }, { value: 'Whale' }, { value: 'Turtle' }],
                                },
                                {
                                    label: 'Placeholder usage',
                                    value: '',
                                    placeholder: 'Placeholder',
                                    items: [{ value: 'Fish' }, { value: 'Bird' }, { value: 'Fox' }],
                                },
                                {
                                    label: 'Filled',
                                    value: 'Lama',
                                    items: [{ value: 'Lama' }, { value: 'Ant' }, { value: 'Cow' }],
                                },
                            ],
                        },
                        {
                            title: 'States',
                            examples: [
                                {
                                    label: 'Focused',
                                    value: '',
                                    placeholder: 'Placeholder',
                                    items: [{ value: 'Dromedary' }, { value: 'Scorpion' }],
                                    focus: true,
                                },
                                {
                                    label: 'Disabled (empty with placeholder)',
                                    value: '',
                                    items: [{ value: 'Monkey' }, { value: 'Dolphin' }],
                                    disabled: true,
                                },
                                {
                                    label: 'Disabled (filled)',
                                    value: 'Beetle',
                                    items: [{ value: 'Beetle' }, { value: 'Crocodile' }],
                                    disabled: true,
                                },
                            ],
                        },
                        {
                            title: 'Form states',
                            examples: [
                                {
                                    label: 'Error state',
                                    value: '',
                                    placeholder: 'Placeholder',
                                    items: [{ value: 'Snake' }, { value: 'Mule' }],
                                    'has-errors': true,
                                    messages: { error: ['Error message'] },
                                },
                            ],
                        },
                    ],
                },
                nested: {
                    options: {
                        facets: ['base'],
                        title: 'Primary text field: Select with optgroup',
                    },
                    sections: [
                        {
                            title: 'Usage',
                            examples: [
                                {
                                    label: 'Nested items',
                                    value: '',
                                    items: [
                                        {
                                            label: 'Pets',
                                            items: [{ value: 'Cat' }, { value: 'Dog' }, { value: 'Mouse' }, { value: 'Whale' }, { value: 'Turtle' }],
                                        }, {
                                            label: 'Wild',
                                            items: [{ value: 'Fish' }, { value: 'Bird' }, { value: 'Fox' }],
                                        }, {
                                            label: 'Fancy',
                                            items: [{ value: 'Lama' }, { value: 'Ant' }, { value: 'Cow' }],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            },
            radio: {
                options: {
                    facets: ['base'],
                    title: 'Primary boolean field: Radio',
                },
                sections: [
                    {
                        title: 'Usage',
                        examples: [
                            {
                                label: 'Horizontal',
                                value: '',
                                items: [{ value: 'Cat' }, { value: 'Dog' }, { value: 'Mouse' }, { value: 'Whale' }, { value: 'Turtle' }],
                            },
                            {
                                label: 'Vertical (one line)',
                                facets: ['vertical', 'base'],
                                value: '',
                                items: [{ value: 'Fish' }, { value: 'Bird' }, { value: 'Fox' }],
                            },
                            {
                                label: 'Vertical (multiline)',
                                facets: ['vertical', 'base'],
                                value: '',
                                items: [
                                    {
                                        value: 'Commodi consequatur debitis ex, modi omnis saepe unde. Dicta, error expedita itaque numquam obcaecati omnis totam vero.',
                                        facets: ['multiline', 'base'],
                                    },
                                    {
                                        value: 'Accusamus consequuntur culpa est, libero maxime placeat velit!',
                                        facets: ['multiline', 'base'],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: 'States',
                        examples: [
                            {
                                label: 'Basic states',
                                facets: ['vertical', 'base'],
                                value: 'Checked',
                                items: [
                                    { value: 'Unchecked' },
                                    { value: 'Checked' },
                                    { value: 'Hovered', facets: ['sty-hover', 'base'] },
                                    { value: 'Focused', facets: ['sty-focus', 'base'] },
                                    { value: 'Disabled', disabled: true },
                                    {
                                        value: 'Disabled / Pseudochecked',
                                        facets: ['sty-checked', 'base'],
                                        disabled: true,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: 'Form states',
                        examples: [
                            {
                                label: 'Error state',
                                facets: ['vertical', 'base'],
                                value: 'Checked',
                                items: [
                                    { value: 'Unchecked' },
                                    { value: 'Checked' },
                                    { value: 'Hovered', facets: ['sty-hover', 'base'] },
                                    { value: 'Focused', facets: ['sty-focus', 'base'] },
                                    { value: 'Disabled', disabled: true },
                                    {
                                        value: 'Disabled / Pseudochecked',
                                        facets: ['sty-checked', 'base'],
                                        disabled: true,
                                    },
                                ],
                                'has-errors': true,
                                messages: { error: ['Error message'] },
                            },
                        ],
                    },
                ],
            },
            checkbox: {
                options: {
                    facets: ['base'],
                    title: 'Primary boolean field: Checkbox',
                },
                sections: [
                    {
                        title: 'Usage',
                        examples: [
                            {
                                label: 'Horizontal',
                                value: [],
                                items: [{ value: 'Apple' }, { value: 'Pear' }, { value: 'Banana' }, { value: 'Orange' }, { value: 'Kiwi' }],
                            },
                            {
                                label: 'Vertical (one line)',
                                facets: ['vertical', 'base'],
                                value: [],
                                items: [{ value: 'Melon' }, { value: 'Pomgrenade' }],
                            },
                            {
                                label: 'Vertical (multiline)',
                                facets: ['vertical', 'base'],
                                value: [],
                                items: [
                                    {
                                        value: 'Architecto dolorem dolorum excepturi exercitationem maiores natus possimus reiciendis saepe, sed totam!',
                                        facets: ['multiline', 'base'],
                                    },
                                    {
                                        value: 'Facilis ipsam maiores neque nobis pariatur perspiciatis possimus quae.',
                                        facets: ['multiline', 'base'],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: 'States',
                        examples: [
                            {
                                label: 'Basic states',
                                facets: ['vertical', 'base'],
                                value: ['Checked'],
                                items: [
                                    { value: 'Unchecked' },
                                    { value: 'Checked' },
                                    { value: 'Hovered', facets: ['sty-hover', 'base'] },
                                    { value: 'Focused', facets: ['sty-focus', 'base'] },
                                    { value: 'Disabled', disabled: true },
                                    {
                                        value: 'Disabled / Pseudochecked',
                                        facets: ['sty-checked', 'base'],
                                        disabled: true,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: 'Form states',
                        examples: [
                            {
                                label: 'Error states',
                                facets: ['vertical', 'base'],
                                value: ['Checked'],
                                items: [
                                    { value: 'Unchecked' },
                                    { value: 'Checked' },
                                    { value: 'Hovered', facets: ['sty-hover', 'base'] },
                                    { value: 'Focused', facets: ['sty-focus', 'base'] },
                                    { value: 'Disabled', disabled: true },
                                    {
                                        value: 'Disabled / Pseudochecked',
                                        facets: ['sty-checked', 'base'],
                                        disabled: true,
                                    },
                                ],
                                'has-errors': true,
                                messages: { error: ['Error message'] },
                            },
                        ],
                    },
                ],
            },
        },
    },
};
